var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _circle4, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 58,
    viewBox: "0 0 71 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H21V28H16.3L16 25V0Z",
    fill: "#DE372F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8H30V28H25V8Z",
    fill: "#DE372F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37H48V57H43V37Z",
    fill: "#DE372F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18C18.5 23.5228 14.1286 28 9.76389 28C3.34366 28 0 23.5228 0 18C0 12.4772 3.34366 8 9.76389 8C14.1286 8 18.5 12.4772 18.5 18Z",
    fill: "#DE372F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18,
    r: 5.5,
    fill: "#F5F5F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 3,
    r: 3,
    fill: "#DE372F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 32,
    r: 3,
    fill: "#DE372F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 18V28L48.1071 28.0014L53 28V18C53 12.0265 49.2374 8 44.7652 8C42.3758 8 40.3717 9.32792 38.5095 11.342L38.2015 8H34V27V28.0014V40.1933C32.3392 38.2289 30.0506 37 27.7639 37C21.3437 37 18 41.4772 18 47C18 52.5228 21.3437 57 27.7639 57C30.0514 57 32.3408 55.7702 34.0018 53.8046L34.3 57H39V28V27V18.0847C38.8825 15.0765 40.515 12.7659 43.5203 12.7659C46.5257 12.7659 48 15.1092 48 18Z",
    fill: "#DE372F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 47,
    r: 5.5,
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57V47C66 44.1092 64.5257 41.7659 61.5203 41.7659C58.515 41.7659 56.8825 44.0765 57 47.0847V57L52 57.0014V37H56.2015L56.5095 40.342C58.3717 38.3279 60.3758 37 62.7652 37C67.2374 37 71 41.0265 71 47V57L66.1071 57.0014L66 57Z",
    fill: "#DE372F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9c055acbffbd9ae3ec2b3766e6bb922.svg";
export { ForwardRef as ReactComponent };